import { createGlobalState, useEffectOnce } from 'react-use';
window.configFetched = false;
const initialState = {
	exhID: '', // 展覽ID
	Timeout: null, // 重新產生UUID的秒數
	recordAPI: '', // 單向紀錄用API
	recordUser: '', // 單向紀錄用API呼叫用帳號
	recordPassword: '', // 單向紀錄用API呼叫用密碼
	recommandAPI: '', // 推薦用API
	recommendSource: '', // local or remote
	accounts: [], // 帳號
	token: '', // token
	userAPI: '', // 使用者資訊API
};

const useConfigState = createGlobalState(initialState);

const useConfig = () => {
	const [configState, setConfigState] = useConfigState(initialState);

	useEffectOnce(() => {
		if (!window.configFetched) {
			fetch('./config.json')
				.then(response => response.json())
				.then(config => {
					window.configFetched = true;
					setConfigState((state) => {
						return {
							...state,
							...config,
						};
					});
				})
				.catch(error => console.error(error));
		}
	});

	return {
		...configState,
	};
}
export default useConfig;